/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import "./QuotationDetailDrawerHeader.scss";

import { ReactComponent as CloseIcon } from "assets/images/iconsV2/x-close.svg";
import { ReactComponent as ArrowUpIcon } from "assets/images/iconsV2/arrow-narrow-up.svg";
import { ReactComponent as ArrowDownIcon } from "assets/images/iconsV2/arrow-narrow-down.svg";
import { useGetQuotationConsts } from "pages/common/ShipmentQuotesV2/helpers/ShipmentQuotesV2Helpers";

type QuotationDetailDrawerHeaderProps = {
  onClose: () => void;
  quotations: any;
};

function QuotationDetailDrawerHeader({ onClose, quotations = [] }: QuotationDetailDrawerHeaderProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const quotationId = searchParams.get("detail");

  const { showAlternativeQuotesButton, defaultQuotations, quotationsRequireApproval } = useGetQuotationConsts(quotations);

  const listWithCurrentQuotation = useMemo(() => {
    let data: any = [];
    if (showAlternativeQuotesButton) {
      const currentQuotation = quotationsRequireApproval.find((quotation: any) => quotation.reference === quotationId);
      if (currentQuotation) {
        data = [...quotationsRequireApproval];
      }
    }
    if (!showAlternativeQuotesButton || data.length === 0) {
      const currentQuotation = defaultQuotations.find((quotation: any) => quotation.reference === quotationId);
      if (currentQuotation) {
        data = [...defaultQuotations];
      }
    }
    return data;
  }, [showAlternativeQuotesButton, defaultQuotations, quotationsRequireApproval, quotationId]);

  const currentQuotationIndex = listWithCurrentQuotation.findIndex((quotation: any) => quotation.reference === quotationId);
  const isFirstQuotation = currentQuotationIndex === 0;
  const isLastQuotation = currentQuotationIndex === listWithCurrentQuotation.length - 1;

  const handlePreviousQuotation = () => {
    if (isFirstQuotation || currentQuotationIndex === -1) return;
    const previousQuotation = listWithCurrentQuotation[currentQuotationIndex - 1];
    if (previousQuotation) {
      searchParams.set("detail", previousQuotation.reference);
      setSearchParams(searchParams);
    }
  };

  const handleNextQuotation = () => {
    if (isLastQuotation || currentQuotationIndex === -1) return;
    const nextQuotation = listWithCurrentQuotation[currentQuotationIndex + 1];
    if (nextQuotation) {
      searchParams.set("detail", nextQuotation.reference);
      setSearchParams(searchParams);
    }
  };

  return (
    <div className="quotation-detail-drawer-header">
      <div className="d-flex align-items-center">
        <div className="d-flex align-items-center">
          <div
            className={`cursor-pointer p-md pagination-button ${
              isFirstQuotation || currentQuotationIndex === -1 ? "disabled" : ""
            }`}
            onClick={handlePreviousQuotation}
          >
            <ArrowUpIcon />
          </div>
          <div
            className={`cursor-pointer p-md pagination-button ${
              isLastQuotation || currentQuotationIndex === -1 ? "disabled" : ""
            }`}
            onClick={handleNextQuotation}
          >
            <ArrowDownIcon />
          </div>
        </div>
        <div className="quotation-detail-drawer-header__divider" />
        <p className="text-sm font-medium fg-secondary ml-md">Quote details</p>
      </div>
      <div>
        <CloseIcon className="cursor-pointer" onClick={onClose} />
      </div>
    </div>
  );
}

export default QuotationDetailDrawerHeader;
